module.exports = __webpack_public_path__ + "static/forecast/weather/nightcloud-74fdbf128b1a6c4302602489a9fed105.svg";